import { moduleFactory } from "@/store/resource";

const resourceModule = moduleFactory("user");
resourceModule.state.me = Laravel.user;
resourceModule.mutations.me = (state, user) => {
  state.me = user;
};
resourceModule.getters.me = ({ me }) => me;
resourceModule.getters.auth = ({ me }) => me !== null;
resourceModule.getters.meHasRole = ({ me }, getters) => roleName => {
  return getters.auth
    ? me.roles.filter(role => {
        return role.name === roleName;
      }).length > 0
    : false;
};
resourceModule.getters.meHasPermissionTo = (
  { me },
  getters
) => permissionName => {
  return getters.auth
    ? me.all_permissions.filter(permission => {
        return permission.name === permissionName;
      }).length > 0
    : false;
};
resourceModule.getters.authCustomerProfile = ({ me }) => {
  if (!me || !me.customer_profile || me.customer_profile.length === 0) {
    return null;
  }

  return me.customer_profile;
};
resourceModule.getters.unreadMessages = (state, getters) => {
  if (
    !getters.authCustomerProfile ||
    !getters.authCustomerProfile.all_unread_messages
  ) {
    return [];
  }

  return getters.authCustomerProfile.unread_messages;
};
resourceModule.getters.unreadNews = (state, getters) => {
  if (
    !getters.authCustomerProfile ||
    !getters.authCustomerProfile.unread_news
  ) {
    return 0;
  }

  return getters.authCustomerProfile.unread_news;
};
resourceModule.mutations.addUnreadMessage = (state, message) => {
  state.me.customer_profile.unread_messages.push(message);
};
resourceModule.mutations.removeUnreadMessages = (state, ids) => {
  let unreadMessages = state.me.customer_profile.unread_messages;
  ids.forEach(id => {
    let index = unreadMessages.findIndex(message => message.id === id);
    if (index >= 0) {
      unreadMessages.splice(index, 1);
    }
  });
};
resourceModule.mutations.removeUnreadNews = state => {
  state.me.customer_profile.unread_news -= 1;
};

export const userModule = resourceModule;
